"use client"
import React, { useState } from 'react';

const FaqsBlogs = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* // <div className="faq-item" style={{ marginBottom: '10px', border: '1px solid #ccc', borderRadius: '5px' }}> */}
      {/* <div 
        className="faq-question" 
        onClick={toggleAnswer}  
        style={{ padding: '15px', background: '#f9f9f9', cursor: 'pointer' }}
      >
       <b>{question}</b>
      </div>
      {isOpen && (
        <div className="faq-answer" style={{ padding: '15px', background: '#fff' }}>
          <p>{answer}</p>
        </div>
      )} */}

      {/* <h1 id="how-hrm-contributes-to-business-success">Hello</h1> */}

      <dl className="toggle" key={index}>
        <dt
          onClick={toggleAnswer}
        >
          <a style={{ borderTop: 'none' }} >
            <h3>
              <b>{question}</b>
            </h3>
          </a>
        </dt>
        {isOpen && (
          <dd
            className="black faqAnswer"
          >
            <h4>
              <p>{answer}</p>
            </h4>
          </dd>
        )}
      </dl>

      {/* // </div> */}
    </>
  );
};

export default FaqsBlogs;
